// 模組07 訊息功能 — mock 種子資料
// 版面依 Figma DCK-07-01-02_查詢(node 122:24576):訊息 feed(非表格)。
// 每則通知的欄位對準設計:
//   category  分頁類別(v2 2128:29123):資料未填｜到期類型｜低於庫存｜審核流程｜告警類型｜版本更新
//   source    來源模組(驅動圖示/標題):審核訊息｜批次匯入｜營運資訊｜資產管理｜
//             監控派工｜訊息功能｜決策分析｜人員管理
//   type      8/30 核心語意:EOS｜EOL｜CVE｜KEV｜合約到期｜審核｜轉派(保留供搜尋/報表)
//   docNo     單據編號(審核類才有,如 RQ-20260605-012)
//   message   內文敘述
//   channel   通知管道:站內＆Email｜站內
//   read      是否已讀(未讀 → feed 左側紅點;驅動「未讀」分頁與「全部標示已讀」)
//   overdue   是否逾期(顯示紅色「到期」標籤)
//   actionLabel 右側連結文字:前往審核｜前往資產｜前往報表｜前往合約｜前往工作項目
//   createdAt 發生時間

// issue 14:種子時間改「相對現在」——設計稿情境是近期通知(1 小時前/今天 09:12),
// 固定日期放久了會全部掉進 >7 天的絕對日期 fallback,demo 永遠看不到相對時間。
const minutesAgo = (m) => new Date(Date.now() - m * 60000).toISOString();
const daysAgo = (d, atMinute = 0) => minutesAgo(d * 24 * 60 + atMinute);

export const notifications = [
  {
    id: 1,
    category: "審核流程",
    source: "審核訊息",
    type: "審核",
    docNo: "RQ-20260605-012",
    message: "陳雅婷 發動「角色管理－新增」，待您審核。",
    channel: "站內＆Email",
    read: false,
    overdue: false,
    actionLabel: "前往審核",
    createdAt: minutesAgo(35),
  },
  {
    id: 2,
    category: "審核流程",
    source: "批次匯入",
    type: "審核",
    docNo: "RQ-20260605-013",
    message: "批次匯入完成：成功 128 筆，資料已寫入系統。",
    channel: "站內＆Email",
    read: false,
    overdue: false,
    // 「完成」不是「待審」—— 送去審核中心會找不到東西可審,該去看寫進去的資料
    actionLabel: "前往資產",
    createdAt: minutesAgo(70),
  },
  {
    id: 3,
    category: "到期類型",
    source: "資產管理",
    type: "EOS",
    docNo: null,
    message:
      "硬體「Web-Server-01」（Dell PowerEdge R750）之 EOS 日期為 2026/09/15"
      + "（剩 30 天），原廠將停止銷售/部分支援，建議評估汰換計畫。",
    channel: "站內＆Email",
    read: false,
    overdue: false,
    actionLabel: "前往資產",
    createdAt: minutesAgo(3 * 60),
  },
  {
    id: 4,
    category: "到期類型",
    source: "資產管理",
    type: "EOL",
    docNo: null,
    message:
      "硬體「DB-Server-01」（HPE ProLiant DL380）之 EOL 日期為 2026/10/15"
      + "（剩 60 天），原廠支援即將終止，屬高風險資產請優先處理。",
    channel: "站內＆Email",
    read: false,
    overdue: true,
    actionLabel: "前往資產",
    createdAt: daysAgo(1, 30),
  },
  {
    id: 5,
    category: "到期類型",
    source: "資產管理",
    type: "CVE",
    docNo: null,
    message:
      "硬體「Dell PowerEdge R750」新增 3 筆未修補 CVE（最高嚴重度：嚴重），"
      + "請至未修補 CVE 報表查看明細。",
    channel: "站內",
    read: true,
    overdue: false,
    actionLabel: "前往報表",
    createdAt: daysAgo(2, 45),
  },
  {
    id: 6,
    category: "到期類型",
    source: "資產管理",
    type: "KEV",
    docNo: null,
    message: "硬體「HPE ProLiant DL380」命中 CISA KEV 已知遭利用弱點清單，請優先確認修補狀態。",
    channel: "站內＆Email",
    read: false,
    overdue: true,
    actionLabel: "前往報表",
    createdAt: daysAgo(3, 10),
  },
  {
    id: 7,
    category: "到期類型",
    source: "營運資訊",
    type: "合約到期",
    docNo: null,
    message: "合約「機房維運服務合約 2026」將於 90 天後（2026/10/15）到期，請評估續約或結案作業。",
    channel: "站內＆Email",
    read: true,
    overdue: false,
    actionLabel: "前往合約",
    createdAt: daysAgo(4, 20),
  },
  {
    id: 8,
    category: "審核流程",
    source: "人員管理",
    type: "轉派",
    docNo: "RQ-20260605-012",
    message: "陳雅婷 已將 2 項工作項目轉派給您（核准生效），請至「工作項目」查看。",
    channel: "站內",
    read: true,
    overdue: false,
    actionLabel: "前往工作項目",
    createdAt: daysAgo(5, 5),
  },
  {
    id: 9,
    category: "審核流程",
    source: "審核訊息",
    type: "審核",
    docNo: "RQ-20260605-014",
    message: "「機房位置－新增」已送出審核，系統已通知第一關簽核人。",
    channel: "站內",
    read: true,
    overdue: false,
    actionLabel: "前往審核",
    createdAt: daysAgo(6, 15),
  },
  {
    id: 10,
    category: "資料未填",
    source: "資產管理",
    type: "資料未填",
    docNo: null,
    message: "硬體「SRV-A01-004」尚有 3 個必填欄位未填寫，請補齊納管資料。",
    channel: "站內＆Email",
    read: false,
    overdue: false,
    actionLabel: "前往資產",
    createdAt: minutesAgo(5 * 60),
  },
  {
    id: 11,
    category: "低於庫存",
    source: "資產管理",
    type: "低於庫存",
    docNo: null,
    message: "備品「電源模組 750W」庫存低於安全水位（2／5），請評估補貨。",
    channel: "站內",
    read: true,
    overdue: false,
    actionLabel: "前往資產",
    createdAt: daysAgo(1, 60),
  },
  {
    id: 12,
    category: "告警類型",
    source: "監控派工",
    type: "告警",
    docNo: null,
    message: "設備「SRV-A01-001」（10.10.32.15，台北A棟主機房／A-R07）自 09:12 起無回應（Down），請確認設備狀態。",
    channel: "站內＆Email",
    read: false,
    overdue: false,
    actionLabel: "前往資產",
    createdAt: minutesAgo(15),
  },
  {
    id: 13,
    category: "版本更新",
    source: "資產管理",
    type: "版本更新",
    docNo: null,
    message: "軟體「Windows Server 2019」有新的安全性更新版本，請評估排程更新。",
    channel: "站內",
    read: true,
    overdue: false,
    actionLabel: "前往報表",
    createdAt: daysAgo(2, 90),
  },
  {
    id: 15,
    category: "版本更新",
    source: "訊息功能",
    type: "審核",
    docNo: null,
    message: "系統將於 2026/08/15 02:00 進行版本更新維護，期間服務短暫中斷。",
    channel: "站內",
    read: true,
    overdue: false,
    actionLabel: "前往報表",
    createdAt: daysAgo(3, 200),
  },
  {
    // 稿 I2128:29144:「訊息功能」這個來源存在的理由就是這一則 —— 簽核卡住的催辦。
    // 原本種子沒有它,八個來源的樣板就少了一種語意。
    id: 17,
    category: "審核流程",
    source: "訊息功能",
    type: "審核",
    docNo: "RQ-20260605-012",
    message: "已等待您審核超過 3 天（第 2 次提醒），逾期將通知您的上層主管。",
    channel: "站內＆Email",
    read: false,
    overdue: true,
    actionLabel: "前往審核",
    createdAt: daysAgo(3, 15),
  },
  {
    id: 16,
    category: "告警類型",
    source: "決策分析",
    type: "CVE",
    docNo: null,
    message: "告警預測：機房「台北內湖機房」下月用電預估超出契約容量 8%，建議提前調度。",
    channel: "站內＆Email",
    read: true,
    overdue: false,
    actionLabel: "前往報表",
    createdAt: daysAgo(4, 300),
  },
];

